<template>
    <v-carousel
        :cycle="false"
        height="400"
        hide-delimiter-background
        hide-delimiters
        show-arrows-on-hover
    >
        <v-carousel-item
            v-for="(item, index) in items"
            :key="index"
            :src="item.src"
            reverse-transition="fade-transition"
            transition="fade-transition"
        />
    </v-carousel>
</template>

<script>
export default {
    data: () => ({
        items: [
            {
                src: '/img/carousel/drogueria-frontview.jpg'
            },
            {
                src: '/img/carousel/storage.jpg'
            }
        ]
    })
};
</script>
